import { createContext } from "react"

const Intro = createContext()

export default Intro
